import { useBlocker, useLocation } from "react-router-dom";

import { DeclineProperty } from "@covertree/new-business-uw-decision";
import { isTestEnv } from "@covertree/utils";
import { OVERVIEW_PATH, SEQUOIA_PATH } from "@routing/paths";

const ALLOWED_PATHS = [OVERVIEW_PATH, SEQUOIA_PATH];

export function DeclinePropertyStep() {
  const location = useLocation();

  useBlocker(({ nextLocation }) => {
    return (
      !isTestEnv &&
      !ALLOWED_PATHS.some((path) => nextLocation.pathname.endsWith(path))
    );
  });

  return (
    <DeclineProperty
      underwritingDecision={location?.state?.underwritingDecision}
    />
  );
}
